import { COLORS } from '@btime/constants'
import { fromNow } from '@btime/helpers'
import React from 'react'

import { SmallText, Text } from '../../../../components/presentation/Text'
import { useAccordionActions } from '../../../../components/structure/accordion/AccordionHandler'
import Accordion from '../../../../components/structure/accordion/Accordion'
import AccordionToggler from '../../../../components/structure/accordion/AccordionToggler'
import EventDropdown from './EventDropdown'
import FlexGrid, { FlexCol } from '../../../../components/structure/FlexGrid'
import Icon from '../../../../components/shapes/Icon'
import Link from '../../../../components/actions/Link'
import Replies from '../replies/Replies'
import StatusTag from '../../../../containers/serviceOrders/StatusTag'
import UserPresenter from '../../../../containers/users/UserPresenter'

const getColor = type => {
  switch (type) {
    case 'instance':
      return COLORS.red
    case 'conclusion':
      return COLORS.green
    case 'actionPlan':
      return COLORS.purple
    default:
      return COLORS.dark3
  }
}

const getTypeLabel = type => {
  switch (type) {
    case 'instance':
      return 'Ocorrência'
    case 'conclusion':
      return 'Conclusão'
    case 'actionPlan':
      return 'Plano de ação'
    default:
      return '-'
  }
}

const Event = ({ item }) => {
  const { toggle } = useAccordionActions()
  const checklist = item.serviceOrder?.checklist || item.formReply?.form?.checklist
  const user = item.serviceOrder?.user
  const group = item.serviceOrder?.group

  return (
    <FlexGrid justify="flex-start" gutter={0.4}>
      {!!item.reply ? <AccordionToggler /> : <Icon name="BsDash" color={COLORS.dark5} size="0.9rem" />}
      <FlexCol flex={3}>
        <Link onClick={() => !!item.reply && toggle()} block>
          <Text size="xsmall">
            {item.serviceOrder?.yearlyId || item.formReply?.form?.name} | {getTypeLabel(item.type)}
          </Text>
          <Text bold>{item.serviceOrder?.name || checklist?.name}</Text>
        </Link>
      </FlexCol>

      <FlexCol flex={2}>
        {!!user && <UserPresenter user={user} size="xsmall" hideIcon />}
        {!!group && <SmallText>{group?.name}</SmallText>}
        {!user && !group && <SmallText>Resposta #{item.formReply?.number}</SmallText>}
      </FlexCol>

      <FlexCol flex={1}>{item.type === 'actionPlan' && <StatusTag item={item.serviceOrder?.status} />}</FlexCol>

      <FlexCol flex={1}>
        <Text size="xsmall">{fromNow(item.insertedAt)}</Text>
      </FlexCol>

      <FlexCol width="2rem">
        <EventDropdown event={item} />
      </FlexCol>
    </FlexGrid>
  )
}

const Wrapper = ({ startsOpen, ...props }) => (
  <Accordion lineBorder noMargin smallPadding borderLeftColor={getColor(props.item.type)} startsOpen={startsOpen}>
    <Event {...props} />
    <Replies mainReply={props.item.reply} {...props} />
  </Accordion>
)

export default Wrapper
